import * as React from 'react';
import PropTypes from 'prop-types';
import { i18n } from '@lt/localization';
import Icon from '../../Icon';

const ExpandControl = ({
  isExpanded,
  toggleHandler,
  collapseText,
  expandText,
  position,
}) => {
  const icon = isExpanded ? (
    <Icon type="collapse-arrows" width={16} height={16} />
  ) : (
    <Icon type="expand-arrows" width={16} height={15} />
  );
  return (
    <div className="map-expand-btn" style={{ [position]: '10px' }}>
      <button type="button" onClick={toggleHandler}>
        {icon}
        {isExpanded ? collapseText : expandText}
      </button>
    </div>
  );
};

ExpandControl.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  toggleHandler: PropTypes.func.isRequired,
  collapseText: PropTypes.string,
  expandText: PropTypes.string,
  position: PropTypes.oneOf(['top', 'bottom']),
};

ExpandControl.defaultProps = {
  collapseText: i18n.t('map.controls.collapse'),
  expandText: i18n.t('map.controls.expand'),
  position: 'top',
};

export default ExpandControl;
